module.exports = __webpack_public_path__ + "2acb60f2/img/SOURCERY_poweredby_web.9819842b.png";